export default () => (
  <footer className="footer">
    <div className="container">
      <div className="content has-text-centered">
        <p className="is-size-7">
          O Serviço de Videoconferências é disponibilizado pela Diretoria de Infraestrutura de Informações - DITI
          <br/>da Secretaria Especial de Tecnologia e Informação - SETI
          <br/>
          <br/> Dúvidas e suporte técnico:
          <a href="https://ati.uffs.edu.br/customer.pl" target="_blank">ati.uffs.edu.br</a>
          <br/>
          <br/> Universidade Federal da Fronteira Sul - UFFS
        </p>
      </div>
    </div>

    <style jsx>{`
      .footer {
        padding: 3rem 1.5rem;
      }
    `}</style>
  </footer>
)


// WEBPACK FOOTER //
// components/shared/AppFooter.js